.container {
  display: inline-flex;
  align-items: stretch;
  width: fit-content;
  height: 32px;
  border: 1px solid var(--color-grey-soft);
  border-radius: map.get($radius, 'xs');
  overflow: hidden;
  background-color: var(--color-surface-primary);
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: var(--color-grey-light);
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-text-primary);
  flex-shrink: 0;

  @include transition(background-color, color);

  &:hover:not(:disabled) {
    background-color: var(--color-grey-soft);
  }

  &:active:not(:disabled) {
    background-color: var(--color-grey-neutral);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: -2px;
  }
}

.buttonDisabled {
  cursor: not-allowed;
  color: var(--color-text-tertiary);

  &:hover {
    background-color: var(--color-grey-light);
  }
}

.value {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 32px;
  border-left: 1px solid var(--color-grey-soft);
  border-right: 1px solid var(--color-grey-soft);
  background-color: var(--color-surface-primary);
  flex-shrink: 0;

  span {
    @include metadata-medium;
    color: var(--color-text-primary);
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;

  .button {
    cursor: not-allowed;
  }

  .value span {
    color: var(--color-text-tertiary);
  }
}
